/** Keep the phone discovery bar out of the hero's purchase CTA. */
(() => {
  const bar = document.querySelector('.ela-sticky-cta');
  const hero = document.querySelector('.ela-hero-carousel');
  if (!bar || !hero || !('IntersectionObserver' in window)) return;

  new IntersectionObserver(([entry]) => {
    bar.hidden = entry.isIntersecting;
  }).observe(hero);
})();
